<template>
    <div v-if="galleryMedia && galleryMedia.length">
        <h4 class="mb-3">What it looks like</h4>
        <carousel :autoPlay="false" class="vh-40 vh-md-30 vh-lg-40" :outerControls="true" @slide="setLocalActive">
            <div class="h-100 rounded me-1 me-md-3 ms-1 ms-md-0 overflow-hidden position-relative" :class="slideCssClass" v-for="(media, index) in galleryMedia" :key="`property-${property.id}-photos-${index}`">
                <lazy-image v-if="media.type == 'image'" :src="media.thumbnail" height="100%" class="clickable" @click.prevent="$emit('openGallery', index)" :autoLoad="(((localActive - 2) <= index) && (index <= (localActive + 2))) ? true : false" :delay="350" />

                <div v-else-if="media.type == 'video'" class="clickable position-relative h-100">
                    <lazy-image :src="media.thumbnail" height="100%" class="clickable" :autoLoad="(((localActive - 2) <= index) && (index <= (localActive + 2))) ? true : false" :delay="350" />
                    <div class="position-absolute top-0 bottom-0 start-0 end-0 d-flex align-items-center justify-content-center" @click.stop="$emit('openGallery', index)" style="background:rgba(0, 0, 0, 0.35)">
                        <i class="far fa-play-circle text-white fs-1"></i>
                    </div>
                </div>

                <div v-else-if="media.type == 'tour'" class="clickable position-relative h-100">
                    <iframe class="d-block w-100 h-100 rounded"  :src="media.url" frameborder="0" scrolling="no" allowfullscreen allowvr="yes"></iframe>
                    <div class="position-absolute top-0 bottom-0 start-0 end-0 d-flex align-items-center justify-content-center" @click.stop="$emit('openGallery', index)">
                        &nbsp;
                    </div>
                </div>

                <div v-if="media.title || media.description" class="position-absolute bottom-0 start-0 end-0 p-2 pe-none" style="background-color:rgba(0, 0, 0, 0.50);">
                    <h6 v-if="media.title" class="mb-1">{{ media.title }}</h6>
                    <div class="text-wrap-pre-line small" v-if="media.description">
                        {{ media.description }}
                    </div>
                </div>
            </div>
        </carousel>
    </div>
</template>

<script type="text/javascript">
    import CommonComponents from '@/components/Common.vue';
    import ApiObject from '@/classes/ApiObject.js';

    import { UseUIStore } from '@/store/UI.js';

    export default {
        components: {
            ...CommonComponents,
        },

        setup() {
            return {
                uiStore: UseUIStore(),
            };
        },

        data() {
            return {
                localActive: 0,
                localActiveTimer: null,
            };
        },

        props: {
            property: {
                type: ApiObject,
                required: true,
            },

            galleryMedia: {
                type: Array,
                required: true,
            },
        },

        emits: ['openGallery'],

        computed: {

            slideCssClass() {
                if (!this.uiStore.isMobile) {
                    return 'half';
                }
                
                return null;
            },
        },

        methods: {
            setLocalActive(slide) {
                clearTimeout(this.localActiveTimer);
                this.localActiveTimer = setTimeout(function() {
                    this.localActive = slide;
                }.bind(this), 750);
            },
        }
    };

</script>
